module.exports = __webpack_public_path__ + "img/machine-translation.e24cd93c.png";